import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=4b8d8e8e&scoped=true"
import script from "./emoji.vue?vue&type=script&lang=js"
export * from "./emoji.vue?vue&type=script&lang=js"
import style0 from "./emoji.vue?vue&type=style&index=0&id=4b8d8e8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8d8e8e",
  null
  
)

export default component.exports